import React, {Component} from "react";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import {currentSiteName} from "../../service/SiteService";

class Platform extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">About the Platform</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>We process requests across a self-healing network of reliable servers to
                                    ensure great uptime, always.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>Our platform has resilience and reliability at its core, meaning that {currentSiteName} remains operational even when bad things happen. Our servers automatically scale to accommodate traffic so that things stay snappy even when we are in a very busy period. In the rare case that server problems occur, our platform automatically replaces the faulty servers with shiny new ones and safely relocates the applications they were running.</p>
                                <p>We are able to achieve speed, scale and safety because our design and engineering approach uses some of the most advanced thinking in our industry. All this means we can spend more time bringing you great new features and improvements to our {currentSiteName} tools.</p>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Platform;



// WEBPACK FOOTER //
// ./src/modules/views/docs/Platform.js